export default __webpack_public_path__ + "static/PromptIconFour-dd38a196f1a6fff701f4dedb143be2f8.png";